export default ({ app }, inject) => {
    const dir = () =>
        app.i18n.locales.find(x => x.code === app.i18n.locale)?.dir || 'ltr'
    inject('dir', dir)
}
